import {init, Models, RematchRootState, RematchDispatch} from "@rematch/core";
import loadingPlugin, {ExtraModelsFromLoading} from "@rematch/loading";

import {auth} from "./auth";
import {app} from "./app"

export interface RootModel extends Models<RootModel> {
    auth: typeof auth
    app: typeof app
}

type FullModel = ExtraModelsFromLoading<RootModel>

const models: RootModel = {
    auth, app
}

export const store = init<RootModel, FullModel>({
    models: models,
    plugins: [loadingPlugin()]
})


export type Store = typeof store
export type Dispatch = RematchDispatch<RootModel>
export type RootState = RematchRootState<RootModel>